import { API } from "../../apiSlice";

export const getTotalLoansApiSlice = API.injectEndpoints({
  endpoints: (builder) => ({
    getTotalLoans: builder.query({
      query: (id) => {
        return {
          url: `users/total-loans`,
        };
      },
    }),
  }),
});

export const { useGetTotalLoansQuery } = getTotalLoansApiSlice;
